import React from 'react';
import { ClassValue } from 'classnames/types';
import Typography, { TypographyProps, SupportedTagName } from '../Typography';
import styles from './SmallText.module.scss';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';

type SmallTextProps<T extends SupportedTagName> = {
  /** Customizable size */
  size?: SupportedSmallTextSize;
} & Omit<TypographyProps<T>, 'font' | 'uppercase' | 'fontWeight'>;
// Alias for backwards compatibility
export type SmallTextAttributes = SmallTextProps<SupportedTagName>;

function SmallText<T extends SupportedTagName>({
  tagName,
  size = 'md',
  className,
  children,
  ...props
}: SmallTextProps<T>) {
  const classNames: ClassValue = [
    styles[`smallText__size_${size.toLowerCase()}`],
    className,
  ];

  return (
    <Typography
      {...props}
      tagName={tagName as SupportedTagName} // this circumvents some weird ts problem
      font="teliasans"
      className={classNames}
      uppercase={false}
      fontWeight="normal"
    >
      {children}
    </Typography>
  );
}

export const supportedSmallTextSizes = ['md', 'sm'] as const;

export type SupportedSmallTextSize = ArrayElementType<
  typeof supportedSmallTextSizes
>;

export default SmallText;
